import { useEffect } from 'react';

import { FacebookLoginClient } from './facebook-login.client';
import { isFacebookApp } from './helpers';
import { DialogParams, InitParams, LoginOptions, FacebookLoginProps, windowWithFB } from './types';

export function FacebookLogin(props: FacebookLoginProps) {
  const {
    appId,
    language = 'en_US',
    fields = 'name,email,picture',
    onSuccess,
    onFail,
    onProfileSuccess,
    className,
    style,
    children = 'Login with Facebook',
    render,
    autoLoad = false,
    useRedirect = false,
    useCustomerChat = false,
  } = props;

  const initParams: InitParams = {
    version: 'v17.0',
    xfbml: false,
    cookie: false,
    localStorage: true,
    ...props.initParams,
    appId,
  };
  const dialogParams: DialogParams = {
    redirect_uri:
      typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '/',
    state: 'facebookdirect',
    response_type: 'code',
    ...props.dialogParams,
    client_id: appId,
  };
  const loginOptions: LoginOptions = {
    return_scopes: false,
    ignoreSdkError: false,
    ...props.loginOptions,
    auth_nonce:
      typeof props.loginOptions?.auth_nonce === 'function'
        ? props.loginOptions.auth_nonce()
        : props.loginOptions?.auth_nonce,
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    await FacebookLoginClient.loadSdk(language, useCustomerChat);
    windowWithFB.fbAsyncInit = () => {
      FacebookLoginClient.init(initParams);
      const isRedirected = FacebookLoginClient.isRedirected(dialogParams);
      if (isRedirected === false && autoLoad) {
        handleButtonClick();
        return;
      }
      if (isRedirected === true && useRedirect) {
        requestLogin();
      }
    };
  };

  const requestLogin = () => {
    FacebookLoginClient.login(
      (res) => {
        if (!res.authResponse) {
          onFail?.({ status: 'loginCancelled' });
          return;
        }

        onSuccess?.(res.authResponse);

        if (onProfileSuccess) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          FacebookLoginClient.getProfile(onProfileSuccess, { fields });
        }
      },
      { ...loginOptions }
    );
  };

  const handleButtonClick = () => {
    if (isFacebookApp() || useRedirect) {
      FacebookLoginClient.redirectToDialog(dialogParams, loginOptions);
      return;
    }

    if (!windowWithFB.FB) {
      onFail?.({ status: 'facebookNotLoaded' });
      return;
    }

    requestLogin();
  };

  if (render) {
    return render({
      onClick: handleButtonClick,
      logout: FacebookLoginClient.logout,
    });
  }

  return (
    <button type="button" onClick={handleButtonClick} className={className} style={style}>
      {children}
    </button>
  );
}
